// extracted by mini-css-extract-plugin
export default {"kitchenWrapper":"KitchenTabContent_kitchenWrapper__j13y4","infoColumn":"KitchenTabContent_infoColumn__WyeRL"};